import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TabGuardClassNames } from 'ag-grid-community';

@Component({
  selector: 'app-scheduled-appointments-modal.component',
  templateUrl: './scheduled-appointments-modal.component.component.html',
  styleUrls: ['./scheduled-appointments-modal.component.component.scss']
})
export class ScheduledAppointmentsModalComponentComponent {
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() lading_uuid: string | undefined | null;
  @Input() field: string = '';

  successfulUpdate = false;

  forms = this.fb.group({
    delivery_date: [new Date()],
    delivery_time: ['00:00'],
    pickup_date: [new Date()],
    pickup_time: ['00:00'],
    appointment_date: [new Date()],
    appointment_start: ['00:00'],
    appointment_end: ['00:00'],
  })
  shipper_timezone: string | null = null;
  consignee_timezone: string | null = null;

  ngOnInit(){
    let url = `/api/work_orders/new_work_order_grid_details.php?uuid=${this.lading_uuid}`;
    // set timezones
    this.http.get<any>(url).subscribe(response => {
      if(response.shipper.address.timezone_id){
        let shipper_timezone: string = response.shipper.address.timezone_id;
      }
      if(response.consignee.address.timezone_id){
        let consignee_timezone: string = response.consignee.address.timezone_id;
      }
    })
  }


  onCloseModal(){
    this.closeModal.emit();
  }

  onSubmit(){
    let postData = {};
    if(this.field === 'pickup'){
      let formattedDateString = this.convertDate(this.forms.get('pickup_date')?.value);
      let formattedTimeString = this.convertTo24Hr(this.forms.get('pickup_time')?.value);
      postData = {
        lading_uuid: this.lading_uuid,
        load_start: this.convertDateTime(this.forms.get('pickup_date')?.value, this.forms.get('pickup_time')?.value)
      }
    }
    else if(this.field === 'delivery'){
      let formattedDateString = this.convertDate(this.forms.get('delivery_date')?.value);
      let formattedTimeString = this.convertTo24Hr(this.forms.get('delivery_time')?.value);
      postData = {
        lading_uuid: this.lading_uuid,
        load_start: this.convertDateTime(this.forms.get('delivery_date')?.value, this.forms.get('delivery_time')?.value)
      }
    }
    else if(this.field === 'appointment'){
      let formattedDateString = this.convertDate(this.forms.get('appointment_date')?.value);
      let formattedStartTime = this.convertTo24Hr(this.forms.get('appointment_start')?.value);
      let formattedEndTime = this.convertTo24Hr(this.forms.get('appointment_end')?.value);
      postData = {
        lading_uuid: this.lading_uuid,
        appointment_date: formattedDateString,
        appointment_start: formattedStartTime,
        appointment_end: formattedEndTime
      }
    }
    else{
      return;
    }
    this.http.post<any>(`/api/work_orders/new_work_order_grid_details.php?uuid=${this.lading_uuid}`, postData).subscribe(
      (response)=> {
        console.log('date/time updated');
        console.log(response);
        this.successfulUpdate = true;
      },
      (error) => {
        console.error('error: ', JSON.stringify(error));
      }
    )
    this.onCloseModal();
  }

  // convert edited date and time into a string before posting
  convertDateTime(date: any, time: any) {
    console.log(`date is ${date?.value} and it is a ${typeof date?.value}`)
    let hours: number;
    let minutes: number;
    // edited times in this format: 9:30 PM
    if (time.dirty) {
      hours = +time?.value.substring(0, time?.value.indexOf(':')) + (+time?.value.includes('P') ? 12 : 0);
      minutes = +time?.value.substring(time?.value.indexOf(':') + 1, time?.value.indexOf(':') + 3);
    }
    // unedited times are in this format: 21:30
    else {
      hours = +time?.value.substring(0, 2)
      minutes = +time?.value.substring(3);
    }

    date?.value.setHours(hours);
    date?.value.setMinutes(minutes);
    return date?.value.toISOString().substring(0, 19).replace('T', ' ');
  }

  convertDate(date: any){
    // Get day, month, and year from dateObject
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is 0-based
    const year = date.getFullYear();

    // Construct the formatted date string
    const formattedDate = this.padZero(month) + '/' + this.padZero(day) + '/' + year;

    return formattedDate;
  }

  convertTo24Hr(timeString: any): string {
    // Parse the time string
    const parts = timeString.split(':');
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1].split(' ')[0]);
    const period = parts[1].split(' ')[1];

    // Adjust hours if necessary
    let formattedHours = hours;
    if (period === 'PM' && hours < 12) {
      formattedHours += 12;
    } else if (period === 'AM' && hours === 12) {
      formattedHours = 0;
    }

    // Format hours and minutes with leading zeros
    const formattedTime = this.padZero(formattedHours) + ':' + this.padZero(minutes);

    return formattedTime;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }

  timezone_regions: {[index: string]: string} = {
    'America/Toronto': 'ON',
    'America/Vancouver': 'BC',
    'America/Edmonton': 'AB',
    'America/Montreal': 'QC',
    'America/Chicago': 'IL',
    'America/Halifax': 'NS',
    'America/Dawson_Creek': 'BC',
    'America/Regina': 'SK',
    'America/Winnipeg': 'MB',
    'America/Los_Angeles': 'CA',
    'America/New_York': 'NY',
    'America/Detroit': 'MI',
    'America/Thunder_Bay': 'ON',
    'America/St_Johns': 'NL',
    'America/Swift_Current': 'SK',
    'America/Denver': 'CO',
    'America/Indiana/Indianapolis': 'IN',
    'America/Indiana/Knox': 'IN',
    'America/Indiana/Marengo': 'IN',
    'America/Indiana/Petersburg': 'IN',
    'America/Indiana/Tell_City': 'IN',
    'America/Indiana/Vevay': 'IN',
    'America/Indiana/Vincennes': 'IN',
    'America/Indiana/Winamac': 'IN',
    'America/Kentucky/Louisville': 'KY',
    'America/Kentucky/Monticello': 'KY',
    'America/North_Dakota/Beulah': 'ND',
    'America/North_Dakota/Center': 'ND',
    'America/North_Dakota/New_Salem': 'ND',
    'America/Boise': 'ID',
    'America/Whitehorse': 'YT',
    'America/Yellowknife': 'NT',
    'America/Rainy_River': 'ON',
    'America/Dawson': 'YT',
    'America/Rankin_Inlet': 'NU',
    'America/Goose_Bay': 'NL',
    'America/Iqaluit': 'NU',
    'America/Inuvik': 'NT',
    'America/Juneau': 'AK',
    'America/Cambridge_Bay': 'NU',
    'America/Yakutat': 'AK'
  }

  constructor(private http: HttpClient, private fb: FormBuilder){}

}
